import ModalContext from 'contexts/ModalProvider';
import { ModalContent } from 'contexts/ModalProvider';
import { useContext } from 'react';

const useModal = () => {
    const { setOpen, setContent } = useContext(ModalContext);

    const setModal = (props: ModalContent) => {
        setContent(props);
        setOpen(true);
    };

    const closeModal = () => {
        setContent({ title: '', component: undefined });
        setOpen(false);
    };

    return { setModal, closeModal };
};

export default useModal;
